"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styles = require("../shared/styles");
var _jsxRuntime = require("react/jsx-runtime");
var ProgressBarBackground = _styledComponents.default.div.withConfig({
  displayName: "ProgressBar__ProgressBarBackground",
  componentId: "sc-115c8g-0"
})(["height:8px;width:72px;border-radius:", ";background-color:", ";"], _styles.borderRadius.s, _styles.colors.background.secondary.default);
var ProgressBarFill = _styledComponents.default.div.withConfig({
  displayName: "ProgressBar__ProgressBarFill",
  componentId: "sc-115c8g-1"
})(["height:inherit;width:", "%;border-radius:inherit;background-color:", ";"], function (_ref) {
  var progress = _ref.progress;
  return progress;
}, function (_ref2) {
  var progress = _ref2.progress;
  return progress === 100 ? _styles.colors.background.creative.default : _styles.colors.background.brand;
});
var ProgressBar = function ProgressBar(_ref3) {
  var progress = _ref3.progress;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(ProgressBarBackground, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(ProgressBarFill, {
      progress: progress
    })
  });
};
ProgressBar.defaultProps = {
  progress: 30
};
var _default = exports.default = ProgressBar;